import React from 'react';
import { AlertTriangle, ChevronRight } from 'lucide-react';
import { cn } from './lib/utils';
import { ICON_PX } from './lib/iconSizes';

/**
 * Clickable alert row — displays a warning with navigation affordance.
 *
 * Used inside BriefCard or standalone for critical/regulatory alerts.
 * Red background, warning icon, full-row click target with chevron.
 *
 * <AlertRow onClick={() => navigate('/workflows/123')}>
 *   Quarterly Fire Drill Documentation only 0% complete — regulatory compliance at risk
 * </AlertRow>
 */
function AlertRow({ children, onClick, className }) {
  return (
    <div
      role="button"
      tabIndex={0}
      className={cn(
        'rounded-md bg-red-bg px-3 py-2 flex items-center gap-2.5',
        'cursor-pointer hover:bg-red-100 transition-colors',
        'outline-none focus-visible:ring-2 focus-visible:ring-aqua/50',
        className,
      )}
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick?.()}
    >
      <AlertTriangle size={ICON_PX.md} className="text-red-critical shrink-0" />
      <span className="text-body-sm text-text-dark flex-1">{children}</span>
      <ChevronRight size={ICON_PX.sm} className="text-red-critical shrink-0" />
    </div>
  );
}

export { AlertRow };
